export const videoPreviewOptions = {
    handlers: {
        brokerSlide: {
            template: ".video-slideshow__broker-slide--template--js",
            agentPhone: ".video-slideshow__broker__slide-overlay-phone--js",
            agentEmail: ".video-slideshow__broker__slide-overlay-email--js",
            agentWebsite: ".video-slideshow__broker-slide__overlay-website--js",
            brokerImage: ".video-slideshow__broker-slide__broker-image--js",
            cta: ".video-slideshow__broker__slide-overlay-cta--js",
        },
        videoSlidesJSONBlobHandler: ".videoSlides--js",
        agentImage: ".video-slideshow__agent-slide__agent-image--js",
        brokerName: ".video-slideshow__agent-slide__broker-name--js",
        budgetOptionsHandler: ".budget--js",
        llpLocationHandler: ".llp-location--js",
        llpLocationHandlerError: ".llp-location-error--js",
        chooseListingHandleError: ".choose-ad-type-error--js",
        headLineHandler: ".headline--js",
        descriptionHandler: ".description-input--js",
        displayFieldsWrapperHandler: ".edit-boost-ad__display--js",
        sampleVideoHandler: ".ad-preview__img--video--js",
        chosenImageHandler: ".ad-preview__img--js",
        videoSlideShowHandler: ".video-slideshow--js",
        agentSlidePreviewHandler:
            ".video-slides-modal__agent__agent-slide__preview--js",
        brokerSlidePreviewHandler:
            ".video-slides-modal__agent__broker-slide-preview--js",
        agentEditModalAgentName: '[name="social_ad_primary_text_duplicate"]',

        videoSlideShowSliderHandler: ".video-slideshow__slider--js",
        videoBaseClass: "video-slideshow",
        videoSlideBaseClass: "video-slideshow__slide",
        videoSlideClass: "video-slideshow__slide--js",
        videoSlideHandler: ".video-slideshow__slide--js",
        videoSlideTemplateOnlyClass: "video-slideshow__slide-template--js",
        videoSlideShowTemplateOnlyStyleClass:
            "video-slideshow__slide--template",
        videoSlideTemplateOnlyHandler: ".video-slideshow__slide-template--js",
        videoSlideCaptionHandler: ".video-slideshow__slide-caption--js",
        agentName: ".video-slideshow__agent-slide__agent-name--js",
        agentSlideTemplate: ".video-slideshow__agent-slide-template--js",
    },

    classes: {
        videoSlideShowExtraMargin: "video-slideshow--extra-margin",
        videoBase: "video-slideshow",
        videoSlideBase: "video-slideshow__slide",
        videoSlide: "video-slideshow__slide--js",
        videoSlideTemplateOnly: "video-slideshow__slide-template--js",
        slideShowTemplateOnly: "video-slideshow__slide--template",
        agentSlideTemplate: "video-slideshow__agent-slide-template--js",
        agentSlideTemplateOnlyFrontEnd:
            "video-slideshow__agent-slide--template",
        agentImage: "video-slideshow__agent-slide__agent-image--js",
        agentName: "video-slideshow__agent-slide__agent-name--js",
        brokerName: "video-slideshow__agent-slide__broker-name--js",

        brokerSlide: {
            templateFrontEnd: "video-slideshow__broker-slide--template",
            template: "video-slideshow__broker-slide--template--js",
            agentPhone: "video-slideshow__broker__slide-overlay-phone--js",
            agentEmail: "video-slideshow__broker__slide-overlay-email--js",
            agentWebsite: "video-slideshow__broker-slide__overlay-website--js",
            cta: "video-slideshow__broker__slide-overlay-cta--js",
        },
    },
};
